import { request } from "../http/api-client";

export async function changePassword(payload: {
  currentPassword: string;
  newPassword: string;
}) {
  const res = await request<{ success: boolean; message: string }>(`/api/v1/auth/change-password`, {
    method: "POST",
    body: {
      currentPassword: payload.currentPassword,
      newPassword: payload.newPassword,
    },
  });
  return res;
}